<div [formGroup]="form">
  <app-review-section
    [title]="'basic-profile.fields.base-data-concession' | translate"
    [showAcceptRejectButtons]="false"
    [showMessages]="false"></app-review-section>

  <div class="ui-g-12 margin-align">
    <label for="float-input-unternehmen" class="ui-g-5 required">
      {{ 'basic-profile.fields.company-concession' | translate }}
    </label>
    <input
      id="float-input-unternehmen"
      type="text"
      size="30"
      pInputText
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="company_name"
      (change)="updateCompany({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-strabe" class="ui-g-5 required">{{ 'basic-profile.fields.street' | translate }}</label>
    <input
      id="float-input-strabe"
      type="text"
      size="30"
      pInputText
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="street"
      (change)="updateCompany({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-hausenummer" class="ui-g-5 required">
      {{ 'basic-profile.fields.street_number' | translate }}
    </label>
    <input
      id="float-input-hausenummer"
      type="text"
      size="30"
      pInputText
      maxlength="5"
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="street_number"
      (change)="updateCompany({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-plz" class="ui-g-5 required">{{ 'basic-profile.fields.postcode' | translate }}</label>
    <input
      id="float-input-plz"
      [appNumber]="true"
      size="30"
      pInputText
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="postcode"
      (change)="updateCompany({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-ort" class="ui-g-5 required">{{ 'basic-profile.fields.city' | translate }}</label>
    <input
      id="float-input-ort"
      type="text"
      size="30"
      pInputText
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="city"
      (change)="updateCompany({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-telephone" class="ui-g-5 required">
      {{ 'basic-profile.fields.telephone-central-concession' | translate }}
    </label>
    <input
      id="float-input-telephone"
      [appNumber]="true"
      size="30"
      pInputText
      maxlength="50"
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="telephone"
      (change)="updateCompany({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label for="float-input-inhaber" class="ui-g-5 required">{{ 'basic-profile.fields.ceo' | translate }}</label>
    <input
      id="float-input-inhaber"
      type="text"
      size="30"
      pInputText
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="ceo"
      (change)="updateCompany({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align" *ngIf="showBaseDataEmail">
    <label for="float-input-email" class="ui-g-5 required">{{ 'basic-profile.fields.mail' | translate }}</label>
    <input
      id="float-input-email"
      type="text"
      size="30"
      pInputText
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="email"
      (change)="updateCompany({ isFromAutosave: true })"
      [attr.disabled]="readonly || null" />
  </div>

  <div class="ui-g-12 margin-align">
    <label class="ui-g-5"></label>
    <p-radioButton
      name="group"
      value="hauptbetrieb"
      [label]="'basic-profile.fields.headquarters-concession' | translate"
      labelStyleClass="required"
      formControlName="headsubsidiary"
      (onClick)="updateCompany({ isFromAutosave: true })"
      [disabled]="readonly"></p-radioButton>
  </div>
  <div class="ui-g-12 margin-align">
    <label class="ui-g-5"></label>
    <p-radioButton
      name="group"
      value="nebenbetrieb"
      [label]="'basic-profile.fields.subsidiary-concession' | translate"
      labelStyleClass="required"
      formControlName="headsubsidiary"
      (onClick)="updateCompany({ isFromAutosave: true })"
      [disabled]="readonly"></p-radioButton>
  </div>
  <div class="ui-g-12 margin-align" *ngIf="showCompanyDescription">
    <label for="input-company-description" class="ui-g-5">{{ 'basic-profile.fields.company-description' | translate }}</label>
    <textarea
      class="h4-button-and-field ui-input pInputText filed-width"
      formControlName="company_description"
      maxlength="4000"
      [disabled]="readonly || null"
      id="input-company-description"
      (change)="updateCompany({ isFromAutosave: true })"
      pInputTextarea
      rows="5"></textarea>
  </div>
  <div class="ui-g-12 margin-align" *ngIf="showMainBusinessesPartTimeRadioBtn">
    <label class="ui-g-5"></label>
    <p-radioButton
      name="group"
      value="main_businesses_part_time"
      [label]="'basic-profile.fields.main_businesses_part_time' | translate"
      labelStyleClass="required"
      formControlName="headsubsidiary"
      (onClick)="updateCompany({ isFromAutosave: true })"
      [disabled]="readonly"></p-radioButton>
  </div>
  <div class="ui-g-12 margin-align" *ngIf="showInAuxiliaryOperationRadioBtn">
    <label class="ui-g-5"></label>
    <p-radioButton
      name="group"
      value="in_auxiliary_operation"
      [label]="'basic-profile.fields.in_auxiliary_operation' | translate"
      labelStyleClass="required"
      formControlName="headsubsidiary"
      (onClick)="updateCompany({ isFromAutosave: true })"
      [disabled]="readonly"></p-radioButton>
  </div>
</div>
